const adminSections = {
    forms: { key: 'forms', name: '{{lang}}Forms', img: '/images/icons/layout.png' },

    // category: { key: 'category', name: 'Categories options', },
    // blog: { key: 'blog', name: 'blogs options', },
    // video: { key: 'video', name: 'videos options', },
    // podcast: { key: 'podcast', name: 'podcasts options', },
    // series: { key: 'series', name: 'series options', },
    // froum: { key: 'settings', name: '{{lang}}Basic settings', img: '/images/icons3/setting-(1).png' },

    report: { key: 'report', name: '{{lang}}Reports', img: '/images/icons/file.png' },

    // categories: { key: 'operation', name: '{{lang}}Operation', img: '/images/icons/computer.png' },
    // product: { key: 'products', name: 'Products option' },
    // messages: { key: 'messages', name: 'messages option' }
}

const adminPages = {


    forms: {
        key: 'forms',
        title: '{{lang}}customer form',
        description: '{{lang}}customer form list',
        // fetchUrl: 'getForms',
        // hideAddButton: true,
        actions: {
            exportRecordPdf: { key: "exportRecordPdf", label: '{{lang}}Export record PDF', color: '#fff', function: "exportRecordPdf", permission: 'view' },
            edit: { key: "edit", label: '{{lang}}edit', color: '#fff', function: "openEditModal", permission: 'edit' },
            remove: { key: "remove", label: '{{lang}}remove', bg: '#d91111', color: '#fff', function: "openRemoveModal", permission: 'delete' }
        },

        fetchUrl: 'getRecords',
        addUrl: 'postRecord',
        editUrl: 'postRecord',
        removeUrl: 'removeRecord',
        // addUrl: 'addForm',
        // editUrl: 'addForm',
        // removeUrl: 'removeForm',
        // options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'forms',
        // options: {},
        sort: { 'cDate': -1 },
        postBody: { applet: '{{applet}}'},
        // addNew: -1,
        importAPIName: [{ key: 'values.model', title: "values.name", value: '_id', schema: 'records' }, { key: 'values.colour', title: "values.name", value: '_id', schema: 'records' }, { key: 'creator', title: "name", value: '_id', schema: 'employees' }, { key: 'applet', title: "name", value: '_id', schema: 'applets' }, { key: 'values.date', isDate: true }, { key: 'values.firstFollowDate', isDate: true }, { key: 'values.secondFollowDate', isDate: true }, { key: 'values.thirdFollowDate', isDate: true }, { key: 'values.forthFollowDate', isDate: true }],
        // extra: { export: { url: 'equipmentExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' }, import: { schema: 'equipments', name: 'import', function: 'openImport', icon: '/images/eye.svg' } },
        extra: {
            import: { schema: 'records', name: '{{lang}}Import', function: 'openImport', icon: '/images/eye.svg' },
            export: { url: 'ExelEquipment', name: '{{lang}}export', function: 'openExport', icon: '/images/eye.svg' }
        },
        // addNew: '/admin/recordInfo',
        image: '/images/kheiry/form1.png',
        sections: {
            female: {
                title: '{{lang}}Female',
                key: 'female',
                color: '#ffe6f1', // light pink
            },
            male: {
                title: '{{lang}}Male',
                key: 'male',
                color: '#e3f0ff', // light blue
            },
            last: {
                // title: '{{lang}}Last',
                key: 'last',
                // color: '#f0f0f0', // light gray
            }
        },
        populates: [ { key: 'values.colour', model: 'records', select: ['values.name'] }, { key: 'creator', model: 'employees', select: ['name'] }, { key: 'applet', model: 'applets', select: ['name'] }, { key: 'values.modelMale', model: 'records', select: ['values.name'] },  { key: 'values.colourMale', model: 'records', select: ['values.name'] }],
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { col: '6', key: 'values.customerName', type: 'TextInput', information: { label: '{{lang}}Customer Name', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.nationalId', type: 'TextInput', information: { label: '{{lang}}national ID', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.birthDate', type: 'JalaliDateInput', information: { label: '{{lang}}Customer Birth Date', disabled: false, required: false }, showMain: false, inExport: true },


            { col: '6', key: 'values.address', type: 'TextInput', information: { label: '{{lang}}Address', disabled: false, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.addressDesc', type: 'TextInput', information: { label: '{{lang}}Address Description', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.postalCode', type: 'TextInput', information: { label: '{{lang}}Postal Code', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.phoneNumber', type: 'PhoneInput', information: { label: '{{lang}}Phone', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.date', type: 'DateInput', information: { label: '{{lang}}formDate', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.dealAmount', type: 'PriceInput', information: { label: 'مبلغ معامله (تومان)', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.settlementMethod', type: 'TextInput', information: { label: 'نحوه تسویه', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.cotractType', type: 'SelectInput', information: { label: '{{lang}}Contract Type', type: 'local', items: [{ value: 'رسمی', title: 'رسمی', color: '#fff', background: 'rgb(0, 122, 255)' }, { value: 'غیر رسمی', title: 'غیر رسمی', background: '#ee5050', color: '#fff' }], isSearchable: true, placeholder: '{{lang}}Select', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.lastFollowUpResult', type: 'SelectInput', information: { label: '{{lang}}lastFollowUpResult', type: 'local', items: [{ value: 'در حال مذاکره', title: 'در حال مذاکره', color: '#fff', background: 'rgb(0, 122, 255)' }, { value: 'منصرف شده', title: 'منصرف شده', background: '#ee5050', color: '#fff' }, { value: 'پیش قرارداد', title: 'پیش قرارداد', color: '#000', background: 'rgb(255, 197, 0)' }, { value: ' رزرو', title: ' رزرو ', color: '#000', background: 'rgb(127, 223, 240)' }, { value: 'قرارداد', title: 'قرارداد', color: '#fff', background: 'rgb(0, 205, 116)' }], isSearchable: true, placeholder: '{{lang}}Select', required: false }, showMain: true, inExport: true },
            { 
                col: '6', 
                key: 'values.veterinarian', 
                type: 'SelectInput', 
                information: { 
                    // section: 'last',
                    label: '{{lang}}Veterinarian', 
                    updateAfterSelect: true, 
                    isSearchable: false, 
                    address: 'employeeGetAll', 
                    filter: { filter: { userType: 'veterinarian' } }, 
                    fields: { title: 'name', value: '_id' }, 
                    type: 'api', 
                    placeholder: '{{lang}}select', 
                    required: false, 
                    disabled: false 
                }, 
                showMain: true, 
                inExport: true 
            },
            { col: '12', key: 'values.formDescription', type: 'TextAreaInput', information: { label: '{{lang}}Description', disabled: false, required: false }, showMain: false, inExport: true },

            // { col: '6', key: 'values.model', type: 'AdvancedSelectInput', information: { section: 'female', label: '{{lang}}model', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false },
            // dependencies: [{
            //     refKey: 'values.model',
            //     targetKey: 'values.microChipNumber',
            //     conditions: {
            //         root: {
            //             id: 'root',
            //             action: 'or',
            //             conditions: {
            //                 1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
            //             }
            //         }
            //     },
            //     show: false,
            //     init: false,
            //     // changeHeader: { key: 'information.filter.country', value: '@data.values.model.microChip' },
            //      changeValue: {
            //             targetKey: "values.microChipNumber",
            //             value: '@fullData.values.microChip',
            //             conditions: {
            //                 root: {
            //                     id: 'root',
            //                     action: 'and',
            //                     conditions: {
            //                         1: { id: 1, source: { value: '@data.values.model' }, operator: { value: '!=' }, target: { value: null } }
            //                     }
            //                 },
            //             },
            //         }
            // }],
            // showMain: true, inExport: true },
            { col: '6', key: 'values.model', type: 'TextInput', information: { section: 'female', label: '{{lang}}model', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.modelDesc', type: 'TextInput', information: { section: 'female', label: '{{lang}}Model Description', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.modelDad', type: 'TextInput', information: { section: 'female', label: '{{lang}}model Dad', disabled: false, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.modelDad', type: 'AdvancedSelectInput', information: { section: 'female', label: '{{lang}}model Dad', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.modelDadDesc', type: 'TextInput', information: { section: 'female', label: '{{lang}}Model Dad Description', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.modelMom', type: 'TextInput', information: { section: 'female', label: '{{lang}}model Mom', disabled: false, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.modelMom', type: 'AdvancedSelectInput', information: { section: 'female', label: '{{lang}}model Mom', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.modelMomDesc', type: 'TextInput', information: { section: 'female', label: '{{lang}}Model Mom Description', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.modelMomDad', type: 'TextInput', information: { section: 'female',label: '{{lang}}model Mom Dad', disabled: false, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.modelMomDad', type: 'AdvancedSelectInput', information: { section: 'female', label: '{{lang}}model Mom Dad', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.modelMomDadDesc', type: 'TextInput', information: { section: 'female', label: '{{lang}}Model Mom Dad Description', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.colorDesc', type: 'TextInput', information: { section: 'female', label: '{{lang}}momColourDesc', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.colour', type: 'SelectInput', information: { section: 'female', label: '{{lang}}momColour', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'colors' } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.birthDateFemale', type: 'DateInputNew', information: { section: 'female', label: '{{lang}}Female Birth Date', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.microChipNumber', type: 'TextInput', information: { section: 'female', label: '{{lang}}Micro Chip Number Female', disabled: false, required: false }, showMain: false, inExport: true },

            { col: '6', key: 'values.modelMale', type: 'AdvancedSelectInput', information: {dontShowExtraValue:true, section: 'male', label: '{{lang}}model Male', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false },
            dependencies: [{
                refKey: 'values.modelMale',
                targetKey: 'values.microChipNumberMale',
                conditions: {
                    root: {
                        id: 'root',
                        action: 'or',
                        conditions: {
                            1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
                        }
                    }
                },
                show: false,
                init: false,
                // changeHeader: { key: 'information.filter.country', value: '@data.values.model.microChip' },
                changeValue: [
                    {
                        targetKey: "values.microChipNumberMale",
                        value: '@fullData.values.microChip',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.values.modelMale' }, operator: { value: '!=' }, target: { value: null } }
                                }
                            },
                        },
                    },
                    {
                        targetKey: "values.modelMaleDad",
                        value: '@fullData.values.dadName',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.values.modelMale' }, operator: { value: '!=' }, target: { value: null } }
                                }
                            },
                        },
                    },
                    {
                        targetKey: "values.modelMaleDesc",
                        value: '@fullData.values.faName',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.values.modelMale' }, operator: { value: '!=' }, target: { value: null } }
                                }
                            },
                        },
                    },
                    {
                        targetKey: "values.modelMaleMom",
                        value: '@fullData.values.momName',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.values.modelMale' }, operator: { value: '!=' }, target: { value: null } }
                                }
                            },
                        },
                    },
                    {
                        targetKey: "values.modelMaleMomDesc",
                        value: '@fullData.values.modelMaleMomDesc',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.values.modelMale' }, operator: { value: '!=' }, target: { value: null } }
                                }
                            },
                        },
                    },
                    {
                        targetKey: "values.modelMaleDadDesc",
                        value: '@fullData.values.modelMaleDadDesc',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.values.modelMale' }, operator: { value: '!=' }, target: { value: null } }
                                }
                            },
                        },
                    },
                    {
                        targetKey: "values.colorDescMale",
                        value: '@fullData.values.colour',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.values.modelMale' }, operator: { value: '!=' }, target: { value: null } }
                                }
                            },
                        },
                    },
                    {
                        targetKey: "values.colourMale",
                        value: '@fullData.values.colour',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.values.modelMale' }, operator: { value: '!=' }, target: { value: null } }
                                }
                            },
                        },
                    },
                    {
                        targetKey: "values.birthDateMale",
                        value: '@fullData.values.birthDateMale',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.values.modelMale' }, operator: { value: '!=' }, target: { value: null } }
                                }
                            },
                        },
                    }
                ]
            }],
            showMain: true, inExport: true },
            { col: '6', key: 'values.modelMaleDesc', type: 'TextInput', information: { section: 'male', label: '{{lang}}Model Male Description', disabled: true, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.modelMaleDad', type: 'AdvancedSelectInput', information: { section: 'male', label: '{{lang}}model Male Dad', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.modelMaleDad', type: 'TextInput', information: { section: 'male', label: '{{lang}}model Male Dad', disabled: true, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.modelMaleDadDesc', type: 'TextInput', information: { section: 'male', label: '{{lang}}Model Male Dad Description', disabled: true, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.modelMaleMom', type: 'AdvancedSelectInput', information: { section: 'male', label: '{{lang}}model Male Mom', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.modelMaleMom', type: 'TextInput', information: { section: 'male', label: '{{lang}}model Male Mom', disabled: true, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.modelMaleMomDesc', type: 'TextInput', information: { section: 'male', label: '{{lang}}Model Male Mom Description', disabled: true, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.modelMaleMomDad', type: 'AdvancedSelectInput', information: { section: 'male', label: '{{lang}}model Male Mom Dad', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: true, inExport: true },
            // { col: '6', key: 'values.modelMaleMomDad', type: 'TextInput', information: { section: 'male', label: '{{lang}}model Male Mom Dad', disabled: true, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.modelMaleMomDadDesc', type: 'TextInput', information: { section: 'male', label: '{{lang}}Model Male Mom Dad Description', disabled: true, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.colorDescMale', type: 'TextInput', information: { section: 'male', label: '{{lang}}dadColourDesc', disabled: true, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.colorDescMale', type: 'SelectInput', information: {disabled:true, section: 'male', label: '{{lang}}dadColourDesc', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'colors' } }, fields: { title: 'values.enName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false },showMain: false, inExport: true },
            { col: '6', key: 'values.colourMale', type: 'SelectInput', information: {disabled:true, section: 'male', label: '{{lang}}dadColour', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'colors' } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false },showMain: false, inExport: true },
            { col: '6', key: 'values.birthDateMale', type: 'DateInputNew', information: { section: 'male', label: '{{lang}}Male Birth Date', disabled: true, required: false,onlyYear: true }, showMain: false, inExport: true },
            { col: '6', key: 'values.microChipNumberMale', type: 'TextInput', information: { section: 'male', label: '{{lang}}Micro Chip Number Male', disabled: true, required: false }, showMain: false, inExport: true },
            // { col: '6', type: 'FileInput', key: 'values.file', col: '12', information: { label: 'آپلود فایل', single: true, cropper: true, ratio: '1:1', placeholder: '', required: false } },
           
            { col: '6', key: 'applet', type: 'SelectInput', information: { section: 'last', label: '{{lang}}branch', updateAfterSelect: true, isSearchable: false, address: 'getApplets', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: false, hideComponent: true, hideInList: true, inExport: true },
            { col: '6', key: 'values.formId', type: 'TextInput', information: { section: 'last', label: '{{lang}}Form ID', disabled: true, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'creator', type: 'SelectInput', information: { section: 'last', label: '{{lang}}salesperson', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false, restricted: true, defaultUser: true }, showMain: true, inExport: true },

        ],

    },

    contracts: {
        key: 'contracts',
        page: 'forms',
        title: '{{lang}}Contracts',
        description: '{{lang}}Contracts List',
        actions: {
            cancelOrder: { key: "cancelOrder", label: '{{lang}}Cancel Order', bg: '#d91111', color: '#fff', function: "openCancelOrderModal", permission: 'delete' },
            seeStatus: { key: "seeStatus", label: '{{lang}}See Orders Status', color: '#fff', function: "openStatusModal", permission: 'view' },
            exportRecordPdf: { key: "exportRecordPdf", label: '{{lang}}Export record PDF', color: '#fff', function: "exportRecordPdf", permission: 'view' },
            vetLetter: { key: "vetLetter", label: '{{lang}}Download Veterinarian Letter', color: '#fff', function: "downloadWorkflowDocument", permission: 'view', documentField: 'vetLetter', downloadName: 'vet-letter.pdf' },
            pregnancyReport: { key: "pregnancyReport", label: '{{lang}}Download Insemination Report', color: '#fff', function: "downloadWorkflowDocument", permission: 'view', documentField: 'pregnancyReport', downloadName: 'insemination-report.pdf' },
            edit: { key: "edit", label: '{{lang}}edit', color: '#fff', function: "openEditModal", permission: 'edit' },
        },
        fetchUrl: 'getRecords',
        addUrl: 'postRecord',
        editUrl: 'postRecord',
        removeUrl: 'removeRecord',
        pageType: 'form',
        parent: 'forms',
        sort: { 'uDate': -1 },
         addNew: -1,
         noAddNew: true,
        postBody: { 
            applet: '{{applet}}',
            'values.lastFollowUpResult': 'قرارداد'
        },
        indicators: {
            filter: [
                [{ key: 'values.isPregnant' }, '==', true]
            ],
            color: '#22c55e',
            glassy: true,
        },
        image: '/images/kheiry/form1.png',
        populates: [
            { key: 'values.veterinarian', model: 'employees', select: ['name'] },
            { key: 'values.customer', model: 'employees', select: ['name'] },
        ],
        headers: [
            { col: '6', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID', disabled: true, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Last Update Date', disabled: true, required: false, time: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.veterinarian', type: 'SelectInput', information: { label: '{{lang}}Veterinarian', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {filter:{userType: 'veterinarian'}}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.customer', type: 'SelectInput', information: { label: '{{lang}}Customer', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: { filter: { userType: 'horseBreeder' } }, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.currentStatus', type: 'ProfessionalStatusInput', information: { label: '{{lang}}Current Status', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.customerName', type: 'TextInput', information: { label: '{{lang}}Customer Name', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.nationalId', type: 'TextInput', information: { label: '{{lang}}national ID', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.birthDate', type: 'JalaliDateInput', information: { label: '{{lang}}Customer Birth Date', disabled: false, required: false }, showMain: false, inExport: true },


            { col: '6', key: 'values.address', type: 'TextInput', information: { label: '{{lang}}Address', disabled: false, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.addressDesc', type: 'TextInput', information: { label: '{{lang}}Address Description', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.postalCode', type: 'TextInput', information: { label: '{{lang}}Postal Code', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.phoneNumber', type: 'PhoneInput', information: { label: '{{lang}}Phone', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.date', type: 'DateInput', information: { label: '{{lang}}formDate', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.dealAmount', type: 'PriceInput', information: { label: 'مبلغ معامله (تومان)', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.settlementMethod', type: 'TextInput', information: { label: 'نحوه تسویه', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.lastFollowUpResult', type: 'SelectInput', information: { label: '{{lang}}lastFollowUpResult', type: 'local', items: [{ value: 'در حال مذاکره', title: 'در حال مذاکره', color: '#fff', background: 'rgb(0, 122, 255)' }, { value: 'منصرف شده', title: 'منصرف شده', background: '#ee5050', color: '#fff' }, { value: 'پیش قرارداد', title: 'پیش قرارداد', color: '#000', background: 'rgb(255, 197, 0)' }, { value: ' رزرو', title: ' رزرو ', color: '#000', background: 'rgb(127, 223, 240)' }, { value: 'قرارداد', title: 'قرارداد', color: '#fff', background: 'rgb(0, 205, 116)' }], isSearchable: true, placeholder: '{{lang}}Select', required: false }, showMain: true, inExport: true },

            // { col: '6', key: 'values.model', type: 'AdvancedSelectInput', information: { section: 'female', label: '{{lang}}model', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false },
            // dependencies: [{
            //     refKey: 'values.model',
            //     targetKey: 'values.microChipNumber',
            //     conditions: {
            //         root: {
            //             id: 'root',
            //             action: 'or',
            //             conditions: {
            //                 1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
            //             }
            //         }
            //     },
            //     show: false,
            //     init: false,
            //     // changeHeader: { key: 'information.filter.country', value: '@data.values.model.microChip' },
            //      changeValue: {
            //             targetKey: "values.microChipNumber",
            //             value: '@fullData.values.microChip',
            //             conditions: {
            //                 root: {
            //                     id: 'root',
            //                     action: 'and',
            //                     conditions: {
            //                         1: { id: 1, source: { value: '@data.values.model' }, operator: { value: '!=' }, target: { value: null } }
            //                     }
            //                 },
            //             },
            //         }
            // }],
            // showMain: true, inExport: true },
            { col: '6', key: 'values.model', type: 'TextInput', information: { section: 'female', label: '{{lang}}model', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.modelDesc', type: 'TextInput', information: { section: 'female', label: '{{lang}}Model Description', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.modelDad', type: 'TextInput', information: { section: 'female', label: '{{lang}}model Dad', disabled: false, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.modelDad', type: 'AdvancedSelectInput', information: { section: 'female', label: '{{lang}}model Dad', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.modelDadDesc', type: 'TextInput', information: { section: 'female', label: '{{lang}}Model Dad Description', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.modelMom', type: 'TextInput', information: { section: 'female', label: '{{lang}}model Mom', disabled: false, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.modelMom', type: 'AdvancedSelectInput', information: { section: 'female', label: '{{lang}}model Mom', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.modelMomDesc', type: 'TextInput', information: { section: 'female', label: '{{lang}}Model Mom Description', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.modelMomDad', type: 'TextInput', information: { section: 'female',label: '{{lang}}model Mom Dad', disabled: false, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.modelMomDad', type: 'AdvancedSelectInput', information: { section: 'female', label: '{{lang}}model Mom Dad', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.modelMomDadDesc', type: 'TextInput', information: { section: 'female', label: '{{lang}}Model Mom Dad Description', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.colorDesc', type: 'TextInput', information: { section: 'female', label: '{{lang}}Color Mom Description', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.colour', type: 'SelectInput', information: { section: 'female', label: '{{lang}}momColour', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'colors' } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.birthDateFemale', type: 'DateInputNew', information: { section: 'female', label: '{{lang}}Female Birth Date', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.microChipNumber', type: 'TextInput', information: { section: 'female', label: '{{lang}}Micro Chip Number Female', disabled: false, required: false }, showMain: false, inExport: true },

            { col: '6', key: 'values.modelMale', type: 'AdvancedSelectInput', information: {dontShowExtraValue:true, section: 'male', label: '{{lang}}model Male', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false },
            dependencies: [{
                refKey: 'values.modelMale',
                targetKey: 'values.microChipNumberMale',
                conditions: {
                    root: {
                        id: 'root',
                        action: 'or',
                        conditions: {
                            1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
                        }
                    }
                },
                show: false,
                init: false,
                // changeHeader: { key: 'information.filter.country', value: '@data.values.model.microChip' },
                changeValue: [
                    {
                        targetKey: "values.microChipNumberMale",
                        value: '@fullData.values.microChip',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.values.modelMale' }, operator: { value: '!=' }, target: { value: null } }
                                }
                            },
                        },
                    },
                    {
                        targetKey: "values.modelMaleDad",
                        value: '@fullData.values.dadName',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.values.modelMale' }, operator: { value: '!=' }, target: { value: null } }
                                }
                            },
                        },
                    },
                    {
                        targetKey: "values.modelMaleDesc",
                        value: '@fullData.values.faName',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.values.modelMale' }, operator: { value: '!=' }, target: { value: null } }
                                }
                            },
                        },
                    },
                    {
                        targetKey: "values.modelMaleMom",
                        value: '@fullData.values.momName',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.values.modelMale' }, operator: { value: '!=' }, target: { value: null } }
                                }
                            },
                        },
                    },
                    {
                        targetKey: "values.colourMale",
                        value: '@fullData.values.colour',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.values.modelMale' }, operator: { value: '!=' }, target: { value: null } }
                                }
                            },
                        },
                    },
                    {
                        targetKey: "values.birthDateMale",
                        value: '@fullData.values.birthDateMale',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.values.modelMale' }, operator: { value: '!=' }, target: { value: null } }
                                }
                            },
                        },
                    }
                ]
            }],
            showMain: true, inExport: true },
            { col: '6', key: 'values.modelMaleDesc', type: 'TextInput', information: { section: 'male', label: '{{lang}}Model Male Description', disabled: false, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.modelMaleDad', type: 'AdvancedSelectInput', information: { section: 'male', label: '{{lang}}model Male Dad', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.modelMaleDad', type: 'TextInput', information: { section: 'male', label: '{{lang}}model Male Dad', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.modelMaleDadDesc', type: 'TextInput', information: { section: 'male', label: '{{lang}}Model Male Dad Description', disabled: false, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.modelMaleMom', type: 'AdvancedSelectInput', information: { section: 'male', label: '{{lang}}model Male Mom', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.modelMaleMom', type: 'TextInput', information: { section: 'male', label: '{{lang}}model Male Mom', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.modelMaleMomDesc', type: 'TextInput', information: { section: 'male', label: '{{lang}}Model Male Mom Description', disabled: false, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.modelMaleMomDad', type: 'AdvancedSelectInput', information: { section: 'male', label: '{{lang}}model Male Mom Dad', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: true, inExport: true },
            // { col: '6', key: 'values.modelMaleMomDad', type: 'TextInput', information: { section: 'male', label: '{{lang}}model Male Mom Dad', disabled: false, required: false }, showMain: false, inExport: true },
            // { col: '6', key: 'values.modelMaleMomDadDesc', type: 'TextInput', information: { section: 'male', label: '{{lang}}Model Male Mom Dad Description', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.colorDescMale', type: 'TextInput', information: { section: 'male', label: '{{lang}}Color Dad Description', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.colourMale', type: 'SelectInput', information: { section: 'male', label: '{{lang}}dadColour', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'colors' } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.birthDateMale', type: 'DateInputNew', information: { section: 'male', label: '{{lang}}Male Birth Date', disabled: false, required: false,onlyYear: true }, showMain: false, inExport: true },
            { col: '6', key: 'values.microChipNumberMale', type: 'TextInput', information: { section: 'male', label: '{{lang}}Micro Chip Number Male', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.isPregnant', type: 'CheckboxInput', information: { label: '{{lang}}Is Pregnant', required: false, disabled: false }, showMain: true, inExport: true },
            
            { col: '6', key: 'applet', type: 'SelectInput', information: { section: 'last', label: '{{lang}}branch', updateAfterSelect: true, isSearchable: false, address: 'getApplets', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: false, hideComponent: true, hideInList: true, inExport: true },
            { col: '6', key: 'creator', type: 'SelectInput', information: { section: 'last', label: '{{lang}}salesperson', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false, restricted: true, defaultUser: true }, showMain: true, inExport: true },

        ],
    },



    // adminLogs: {
    //     key: "adminLogs",
    //     title: '{{lang}}Admin Logs',
    //     description: '{{lang}}Admin Logs List',
    //     fetchUrl: 'getLogs',
    //     // addUrl: 'addEmployee',
    //     // editUrl: 'addEmployee',
    //     // removeUrl: 'removeEmployee',
    //     pageType: 'form',
    //     page: 'logs',
    //     parent: 'whthoutParent',
    //     postBody: {},

    //     addNew: -1,
    //     options: { noAddNew: true },
    //     actions: {
    //         edit: { key: "edit", label: '{{lang}}view', color: '#fff', function: "openEditModal", permission: 'view' },
    //     },
    //     // tabs: [
    //     //     { title: 'Admins', filter: { "role": 'admin' } },
    //     //     { title: 'Users', filter: { "role": 'user' } },

    //     // ],

    //     image: '/images/kheiry/lock.png',
    //     headers: [
    //         { type: 'TextInput', key: 'name', information: { label: '{{lang}}Name', disabled: true }, showMain: true },
    //         { type: 'TextInput', key: 'phone', information: { label: '{{lang}}Phone', disabled: true }, showMain: true },
    //         { type: 'TextInput', key: 'committer', information: { label: '{{lang}}committed by', disabled: true }, showMain: true },
    //         { type: 'TextInput', key: 'ip', information: { label: '{{lang}}ip', disabled: true }, showMain: true },
    //         { type: 'TextAreaInput', key: 'message', information: { label: '{{lang}}Message', disabled: true }, showMain: true },
    //         { type: 'DateInput', key: 'cDate', information: { label: '{{lang}}Date/Time', time: true, disabled: true }, showMain: true },

    //         { type: 'TextInput', key: 'type', information: { label: '{{lang}}Type', disabled: true }, showMain: true },

    //     ],
    // },


    // leadsreport: {
    //     key: 'leadsreport',
    //     title: '{{lang}}Total Leads Report',
    //     description: '{{lang}}Total Leads Report',
    //     fetchUrl: 'getRecords',
    //     addUrl: 'postRecord',
    //     editUrl: 'postRecord',
    //     removeUrl: 'removeRecord',
    //     options: { noAddNew: true },
    //     pageType: 'leadsreport',
    //     parent: 'report',
    //     hideSection: true,
    //     hideActions: true,
    //     image: '/images/kheiry/crm-04.png',
    //     headers: [],
    // },

    // leadsstatus: {
    //     key: 'leadsstatus',
    //     title: '{{lang}}Leads Status Report',
    //     description: '{{lang}}Leads Status Report',
    //     fetchUrl: 'getRecords',
    //     addUrl: 'postRecord',
    //     editUrl: 'postRecord',
    //     removeUrl: 'removeRecord',
    //     options: { noAddNew: true },
    //     pageType: 'LeadsStatusReport',
    //     parent: 'report',
    //     hideSection: true,
    //     hideActions: true,
    //     image: '/images/kheiry/crm-04.png',
    //     headers: [],
    // },

    // hotleads: {
    //     key: 'hotleads',
    //     title: '{{lang}}Hot Leads Report',
    //     description: '{{lang}}Hot Leads Report',
    //     fetchUrl: 'getRecords',
    //     addUrl: 'postRecord',
    //     editUrl: 'postRecord',
    //     removeUrl: 'removeRecord',
    //     options: { noAddNew: true },
    //     pageType: 'hotLeadsReport',
    //     parent: 'report',
    //     hideSection: true,
    //     hideActions: true,
    //     image: '/images/kheiry/crm-04.png',
    //     headers: [],
    // },


    permissions: {
        key: 'permissions',
        title: 'دسترسی‌های شعبه',
        description: '{{lang}}Permissions List',
        fetchUrl: 'getPermissions',
        removeUrl: 'removePermission',
        // editUrl: 'addValue',
        // removeUrl: 'removeValue',
        pageType: 'form',
        page: 'permissions',
        parent: 'settings',
        image: '/images/kheiry/branchpermit1.png',
        addNew: '../permission',
        hideFilter: true,
        headers: [
            // { key: 'groups', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}useful.groups', placeholder: '{{lang}}useful.groups', required: false, disabled: true }, showMain: true },
            { key: 'users', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}Users', fields: { title: 'username', value: '_id' }, placeholder: '{{lang}}useful.users', required: false, disabled: true, showAllInTable: true }, showMain: true },

            { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: false, disabled: true }, showMain: true },


        ]
    },


    permission: {
        key: 'permission',
        title: 'permission',
        permissionKey: 'permissions',
        description: 'permission List',
        fetchUrl: 'getPermission',
        addUrl: 'addPermission',
        editUrl: 'addPermission',
        // removeUrl: 'removePermission',
        pageType: 'permissions',
        page: 'permissions',
        permissionRules: ['admin.permissions.create', 'admin.permissions.edit'],
        permissionParent: 'permissions',
        // parent: 'admin',
        hidePage: true,
        image: '/images/covers/dashboards.jpg',

        headers: [
            { type: 'TextInput', key: 'email', information: { label: 'Email', }, showMain: true },
            { key: 'status', type: 'SelectInput', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "unsubscribed", value: '0' }, { title: 'active', value: '1' }] }, settings: { required: false }, showMain: true },
        ]
    },


}


export { adminPages, adminSections }
